import {
  Button,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { IYearsButtonProps } from '../../../payroll-accounting.interfaces';

import { YearsButtonWrapper } from './years-buttons.styles';

const clickType = {
  increment: 'increment',
  decrement: 'decrement',
};

const YearsButton = ({ filters, handleFilterChange, maxYear, minYear }: IYearsButtonProps) => {
  const onButtonClick = (type: string) => () => {
    const data = {
      year: filters.year,
    };
    if (type === clickType.increment) {
      data.year = data.year && data.year + 1;
    }
    if (type === clickType.decrement) {
      data.year = data.year && data.year - 1;
    }
    handleFilterChange(data);
  };

  return (
    <YearsButtonWrapper>
      <Button
        ghost
        aria-label={'Left'}
        disabled={maxYear === filters?.year}
        onClick={onButtonClick(clickType.decrement)}
      >
        <Icon
          size={'16px'}
          rightMargin={false}
          color={PLATFORM_THEME_COLORS.primary.blue}
          icon={ICONS.chevronLeft}
        />
      </Button>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {filters.year}
      </Typography>
      <Button
        ghost
        disabled={minYear === filters?.year}
        aria-label={'Right'}
        onClick={onButtonClick(clickType.increment)}
      >
        <Icon
          size={'16px'}
          rightMargin={false}
          color={PLATFORM_THEME_COLORS.primary.blue}
          icon={ICONS.chevronRight}
        />
      </Button>
    </YearsButtonWrapper>
  );
};

export default YearsButton;
